<template>
  <v-card
    class="mx-auto"
    max-width="1200px"
    style="margin-top:10px;"
  >
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>

      <v-snackbar
      :timeout="3000"
      v-model="snackbar"
      top
      color="warning"
    >
      {{ text }}
    </v-snackbar>
    </v-overlay>
    <v-card-title style="background-color:#006699;color:white" >
      Verificar estudante - Em outras instituições
    </v-card-title>
     <v-card-text>
       <v-row>
         <v-col md="12">
            <!-- ============ AREA DE PESQUISA ==================== -->
       <span style="margin-left:10px;margin-top:10px;"><v-chip
       class="ma-2"
      close
      color="primary"
      text-color="white"
     >
      Área de Pesquisa
    </v-chip></span>
            <v-card
             style="margin-left:10px;"
              max-width="1200px"
            >
              <v-card-text class="text--primary">
                 <v-row>
                    <v-col md="3">
                      <label>Instituição</label>

                         <v-combobox
                         :items="instituicoes"
                         item-text="descricao"
                         v-model="editedItem.instituicao"
                          label="Selecione a instituição"
                          outlined
                          return-object
                        ></v-combobox>
                    </v-col>
                    <v-col md="3">
                      <label>Anolectivo</label>
                        <v-select
                          v-model="anolectivoSelected"
                          :items="Listaranoslectivo"
                          label="Filtre pelo anolectivo"
                          item-value="descricao"
                          item-text="novadescricao"
                          outlined
                        ></v-select>
                    </v-col>
                     <v-col md="3">
                      <label>Estudante</label>
                        <v-text-field
                          v-model="editedItem.estudante"
                          label="Pesquise"
                          clearable
                          :disabled=" editedItem.instituicao === ''"
                        ></v-text-field>
                    </v-col>
                    <v-col md="1">
                      <v-btn small @click="Pesquisar(editedItem.estudante)" style="margin-top:20px;" :disabled="editedItem.instituicao === '' || editedItem.estudante === ''" fab color="primary"><v-icon>search</v-icon></v-btn>
                    </v-col>
                    <v-col md="1">
                      <v-btn small @click="Limpar()" style="margin-top:20px;color:white;" :disabled="!estudantes.length" fab color="green" sty><v-icon>delete</v-icon></v-btn>
                    </v-col>
                 </v-row>
              </v-card-text>
            </v-card>
         </v-col>
         <v-col md="12">
              <!-- ============ AREA Dos dados ==================== -->
            <v-card
             style="margin-left:10px;"
              max-width="1200"
            >
              <v-card-text class="text--primary">
                 <v-row>
                    <v-col md="12">
                      <label>Resultado da pesquisa</label>
                         <v-data-table
                          :headers="headers"
                          :items="estudantes"
                          :search="search"
                        >
                           
                            <template v-slot:item.resultado="{ item }">
                              <span style="color:green;" v-if="item.resultado === 'Transita'">Transita	</span>
                              <span style="color:red;" v-if="item.resultado === 'Não Transita' ||item.resultado === '' ">Não Transita	</span>
                            </template>

                            <template v-slot:item.acao="{ item }">
                               <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                  <v-icon color="green darken-3" v-on="on" size="25" class="mr-2" @click="VisualizarHistorico(item)">receipt</v-icon>
                                </template>
                                <span>Visualizar o histórico académico</span>
                              </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-col>
                 </v-row>
              </v-card-text>
            </v-card>
         </v-col>
       </v-row>
     </v-card-text>
  </v-card>
</template>
<script>
import axios from '../../plugins/axios'
var ls = require('local-storage')
  export default {
    data () {
      return {
        anolectivoSelected: ls.get('anolectivo'),
        anolectivoActual: ls.get('anolectivo'),
        message1:'',
        instituicoes: [],
        Listaranoslectivo:[],
        classes: [{id:1,descricao:'10ª Classe'},{id:2,descricao:'11ª Classe'},{id:3,descricao:'12ª Classe'},{id:4,descricao:'13ª Classe'}],
        search: '',
        overlay: false,
        snackbar: false,
        text: '',
        editedItem: {
          instituicao:'',
          estudante: ''
        },
        editedItemDeafult: {
          instituicao:'',
          estudante: ''
        },
        headers: [
          {
            text: 'Nome',
            align: 'start',
            sortable: false,
            value: 'nome',
          },
          { text: 'Bilhete', value: 'bi' },
          { text: 'Matrícula', value: 'idMatricula' },
          { text: 'Curso(Actual)', value: 'curso' },
          { text: 'Classe(Actual)', value: 'classe' },
          { text: 'Turma', value: 'turma' },
          { text: 'Resultado', value: 'resultado' },
          { text: 'Ação', value: 'acao' },
        ],
        estudantes: [],
      }
    },
    created(){
      this.initialize()
      this.initializeAnosLectivo()
    },
    methods: {
        async initialize (searchInDb) {
        try {
          this.instituicoes = await axios
            .get('/listarInstituicao')
            .then(res => res.data)
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          console.log('errrrrrrrrrrrrrrrrrrro' + error)
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      },

      async Pesquisar (searchInDb){

         try {  
           this.overlay = true
            if (!searchInDb) {
            var payload = '{"find":"all"}'
            } else {
              payload = '{"find":"' + searchInDb + '"}'
            }
            this.estudantes = await axios
          .get('/estudanteFindAll-geral-instituicao/' + payload + '/' + this.anolectivoSelected + '/'+ this.editedItem.instituicao.idInstituicao)
          .then(res => res.data)
         } catch (error) {
           this.overlay = false
           //this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
         } finally{
            this.overlay = false
         }
         
      },

      Limpar () {
        this.estudantes = []
        this.editedItem = this.editedItemDeafult
        this.anolectivoSelected = this.anolectivoActual
      },

      VisualizarHistorico (item) {
      this.$store.state.objaluno = item
      this.$router.push('Historico-estudante')
    },
 

    async initializeAnosLectivo () {
      try {
        this.Listaranoslectivo = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
      } catch (error) {
        console.log('errrrrrrrrrrrrrrrrrrro' + error)
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
      }
    }

      // async Pesquisar (){
      //    this.overlay = true
      //    this.snackbar = true
      //    this.text = 'Estudante não encontrado'
      //    setTimeout(() => {
      //      this.overlay = false
      //      this.snackbar = false
      //    }, 1000);
      // }
    }
  }
</script>